// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module__footer___10p7c"};